<template>
	<div>
		<organization-submenu />

		<core-layout-content full>
			<!-- Content -->
			<div class="flex wrap xs-12">
				<core-entity-card
					:entity="fetchedOrganization"
					:pinnable="false"
					:hasActions="true"
					@added="fetchOrganization"
					@updated="fetchOrganization"
					@deleted="fetchOrganization"
				/>
			</div>

			<!-- Footer menu -->
			<div class="flex wrap xs-12 xs-right bt1 bc7 pt2 mt8">
				<j-button
					type="error"
					@click="$modal.show('j-dialog')"
					v-can="'writeInternals'"
				>
					<crm-icon name="delete" size="normal" color="c5" class="mr1" />
					{{ $t("delete_organization") }}
				</j-button>
			</div>

			<!-- Delete Confirmation Modal -->
			<j-dialog
				:title="$t('delete_organization')"
				type="delete"
				@confirm="deleteOrganization"
				>{{
					$t("errors.are_you_sure_you_want_to_delete_organization")
				}}</j-dialog
			>
		</core-layout-content>
	</div>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"
import CoreModal from "@/modules/core/components/CoreModal/"
import OrganizationSubmenu from "./OrganizationSubmenu"

import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JDialog from "@/components/JDialog"
import CrmIcon from "@/components/CrmIcon"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreLayoutContent,
		CoreEntityCard,
		JCard,
		JButton,
		CrmIcon,
		JDialog,
		CoreModal,
		OrganizationSubmenu
	},

	data() {
		return {
			id: this.$route.params.id,
			fetchedOrganization: {}
		}
	},

	methods: {
		async fetchOrganization() {
			this.isLoading = true
			const query = gql`
				query organization($where: organizationWhereInput) {
					organizations(where: $where) {
						list {
							__typename
							id
							createdAt
							name
							internalCode
							source
							isActive
							relationships {
								type
								entity {
									name
									id
								}
							}
						}
					}
				}
			`

			const variables = {
				where: { id: this.$route.params.id }
			}
			const res = await api({ query, variables })
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// If it doesn't exist, redirect
			if (res.data.organizations.list.length === 0)
				this.$router.push({ name: "OrganizationsList" })

			// Assign
			this.fetchedOrganization = res.data.organizations.list[0]
		},

		async deleteOrganization() {
			this.isLoading = true
			const query = gql`
				mutation deleteOrganization($id: String!) {
					deleteEntity(id: $id) {
						status
						errors
					}
				}
			`

			const variables = {
				id: this.$route.params.id
			}

			const res = await api({ query, variables })

			if (res?.data?.deleteEntity?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.deleteOrganization?.errors ||
							"Oops ! An error occured."
					}
				})
			}

			this.isLoading = false
			this.$router.push({ name: "OrganizationsList" })
		}
	},

	created() {
		this.fetchOrganization()
	}
}
</script>
